
import styled from 'styled-components';

export const FlexWrapper = styled.div`
    display: flex;
`;

export const CloseButton = styled.button`
    background: none;
    outline: 0;
    border: 0;
    display: inline-block;
    position: absolute;
    top: 8px;
    right: 8px;
    cursor: pointer
`;